<template>
  <div
    id="app"
    style="min-height: 100%"
  >
    <v-app
      id="ecpl"
      class="cppsbg"
    >
      <v-container>
        <router-view />
      </v-container>
      <ecpl-footer />
    </v-app>
  </div>
</template>

<script>
import EcplFooter from './components/EcplFooter.vue';

export default {
  name: "App",
  components: {
    EcplFooter
  },
  data: () => ({}),
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    logOut() {
      console.log("logging out");
      this.$store.dispatch("auth/logout");
      this.$router.push("/home");
    },
  },
};
</script>

<style>
/* See assets main.css */
</style>

